import * as n from "react";
import { i as p, j as I, t as A, w as R, u as H, l as Q, e as z, p as J, s as T, m as Z, v as he, h as $, x as me, y as Ee, z as ee, A as te, a as ye, c as ge, f as Ne, g as be, k as Re, r as Ce, n as xe, o as _e, q as De } from "./router-lfyopgBI.js";
/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _() {
  return _ = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, _.apply(this, arguments);
}
const F = /* @__PURE__ */ n.createContext(null);
process.env.NODE_ENV !== "production" && (F.displayName = "DataRouter");
const j = /* @__PURE__ */ n.createContext(null);
process.env.NODE_ENV !== "production" && (j.displayName = "DataRouterState");
const B = /* @__PURE__ */ n.createContext(null);
process.env.NODE_ENV !== "production" && (B.displayName = "Await");
const x = /* @__PURE__ */ n.createContext(null);
process.env.NODE_ENV !== "production" && (x.displayName = "Navigation");
const U = /* @__PURE__ */ n.createContext(null);
process.env.NODE_ENV !== "production" && (U.displayName = "Location");
const N = /* @__PURE__ */ n.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (N.displayName = "Route");
const Y = /* @__PURE__ */ n.createContext(null);
process.env.NODE_ENV !== "production" && (Y.displayName = "RouteError");
function Oe(e, t) {
  let {
    relative: r
  } = t === void 0 ? {} : t;
  D() || (process.env.NODE_ENV !== "production" ? p(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : p(!1));
  let {
    basename: a,
    navigator: o
  } = n.useContext(x), {
    hash: l,
    pathname: i,
    search: d
  } = le(e, {
    relative: r
  }), f = i;
  return a !== "/" && (f = i === "/" ? a : I([a, i])), o.createHref({
    pathname: f,
    search: d,
    hash: l
  });
}
function D() {
  return n.useContext(U) != null;
}
function k() {
  return D() || (process.env.NODE_ENV !== "production" ? p(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : p(!1)), n.useContext(U).location;
}
function Pe() {
  return n.useContext(U).navigationType;
}
function Ue(e) {
  D() || (process.env.NODE_ENV !== "production" ? p(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component."
  ) : p(!1));
  let {
    pathname: t
  } = k();
  return n.useMemo(() => Z(e, he(t)), [t, e]);
}
const re = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function ne(e) {
  n.useContext(x).static || n.useLayoutEffect(e);
}
function ae() {
  let {
    isDataRoute: e
  } = n.useContext(N);
  return e ? Ke() : Ve();
}
function Ve() {
  D() || (process.env.NODE_ENV !== "production" ? p(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : p(!1));
  let e = n.useContext(F), {
    basename: t,
    future: r,
    navigator: a
  } = n.useContext(x), {
    matches: o
  } = n.useContext(N), {
    pathname: l
  } = k(), i = JSON.stringify(A(o, r.v7_relativeSplatPath)), d = n.useRef(!1);
  return ne(() => {
    d.current = !0;
  }), n.useCallback(function(u, c) {
    if (c === void 0 && (c = {}), process.env.NODE_ENV !== "production" && R(d.current, re), !d.current) return;
    if (typeof u == "number") {
      a.go(u);
      return;
    }
    let s = H(u, JSON.parse(i), l, c.relative === "path");
    e == null && t !== "/" && (s.pathname = s.pathname === "/" ? t : I([t, s.pathname])), (c.replace ? a.replace : a.push)(s, c.state, c);
  }, [t, a, i, l, e]);
}
const oe = /* @__PURE__ */ n.createContext(null);
function Fe() {
  return n.useContext(oe);
}
function ie(e) {
  let t = n.useContext(N).outlet;
  return t && /* @__PURE__ */ n.createElement(oe.Provider, {
    value: e
  }, t);
}
function ke() {
  let {
    matches: e
  } = n.useContext(N), t = e[e.length - 1];
  return t ? t.params : {};
}
function le(e, t) {
  let {
    relative: r
  } = t === void 0 ? {} : t, {
    future: a
  } = n.useContext(x), {
    matches: o
  } = n.useContext(N), {
    pathname: l
  } = k(), i = JSON.stringify(A(o, a.v7_relativeSplatPath));
  return n.useMemo(() => H(e, JSON.parse(i), l, r === "path"), [e, i, l, r]);
}
function se(e, t) {
  return W(e, t);
}
function W(e, t, r, a) {
  D() || (process.env.NODE_ENV !== "production" ? p(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : p(!1));
  let {
    navigator: o
  } = n.useContext(x), {
    matches: l
  } = n.useContext(N), i = l[l.length - 1], d = i ? i.params : {}, f = i ? i.pathname : "/", u = i ? i.pathnameBase : "/", c = i && i.route;
  if (process.env.NODE_ENV !== "production") {
    let h = c && c.path || "";
    pe(f, !c || h.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + f + '" (under <Route path="' + h + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + h + '"> to <Route ') + ('path="' + (h === "/" ? "*" : h + "/*") + '">.'));
  }
  let s = k(), v;
  if (t) {
    var m;
    let h = typeof t == "string" ? J(t) : t;
    u === "/" || (m = h.pathname) != null && m.startsWith(u) || (process.env.NODE_ENV !== "production" ? p(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + u + '" ') + ('but pathname "' + h.pathname + '" was given in the `location` prop.')) : p(!1)), v = h;
  } else
    v = s;
  let b = v.pathname || "/", C = b;
  if (u !== "/") {
    let h = u.replace(/^\//, "").split("/");
    C = "/" + b.replace(/^\//, "").split("/").slice(h.length).join("/");
  }
  let E = Q(e, {
    pathname: C
  });
  process.env.NODE_ENV !== "production" && (process.env.NODE_ENV !== "production" && R(c || E != null, 'No routes matched location "' + v.pathname + v.search + v.hash + '" '), process.env.NODE_ENV !== "production" && R(E == null || E[E.length - 1].route.element !== void 0 || E[E.length - 1].route.Component !== void 0 || E[E.length - 1].route.lazy !== void 0, 'Matched leaf route at location "' + v.pathname + v.search + v.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
  let V = ue(E && E.map((h) => Object.assign({}, h, {
    params: Object.assign({}, d, h.params),
    pathname: I([
      u,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(h.pathname).pathname : h.pathname
    ]),
    pathnameBase: h.pathnameBase === "/" ? u : I([
      u,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(h.pathnameBase).pathname : h.pathnameBase
    ])
  })), l, r, a);
  return t && V ? /* @__PURE__ */ n.createElement(U.Provider, {
    value: {
      location: _({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, v),
      navigationType: z.Pop
    }
  }, V) : V;
}
function Be() {
  let e = ce(), t = $(e) ? e.status + " " + e.statusText : e instanceof Error ? e.message : JSON.stringify(e), r = e instanceof Error ? e.stack : null, a = "rgba(200,200,200, 0.5)", o = {
    padding: "0.5rem",
    backgroundColor: a
  }, l = {
    padding: "2px 4px",
    backgroundColor: a
  }, i = null;
  return process.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", e), i = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ n.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ n.createElement("code", {
    style: l
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ n.createElement("code", {
    style: l
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ n.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, t), r ? /* @__PURE__ */ n.createElement("pre", {
    style: o
  }, r) : null, i);
}
const Le = /* @__PURE__ */ n.createElement(Be, null);
class Se extends n.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      revalidation: t.revalidation,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return {
      error: t
    };
  }
  static getDerivedStateFromProps(t, r) {
    return r.location !== t.location || r.revalidation !== "idle" && t.revalidation === "idle" ? {
      error: t.error,
      location: t.location,
      revalidation: t.revalidation
    } : {
      error: t.error !== void 0 ? t.error : r.error,
      location: r.location,
      revalidation: t.revalidation || r.revalidation
    };
  }
  componentDidCatch(t, r) {
    console.error("React Router caught the following error during render", t, r);
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ n.createElement(N.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ n.createElement(Y.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function Ie(e) {
  let {
    routeContext: t,
    match: r,
    children: a
  } = e, o = n.useContext(F);
  return o && o.static && o.staticContext && (r.route.errorElement || r.route.ErrorBoundary) && (o.staticContext._deepestRenderedBoundaryId = r.route.id), /* @__PURE__ */ n.createElement(N.Provider, {
    value: t
  }, a);
}
function ue(e, t, r, a) {
  var o;
  if (t === void 0 && (t = []), r === void 0 && (r = null), a === void 0 && (a = null), e == null) {
    var l;
    if (!r)
      return null;
    if (r.errors)
      e = r.matches;
    else if ((l = a) != null && l.v7_partialHydration && t.length === 0 && !r.initialized && r.matches.length > 0)
      e = r.matches;
    else
      return null;
  }
  let i = e, d = (o = r) == null ? void 0 : o.errors;
  if (d != null) {
    let c = i.findIndex((s) => s.route.id && (d == null ? void 0 : d[s.route.id]) !== void 0);
    c >= 0 || (process.env.NODE_ENV !== "production" ? p(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(d).join(",")) : p(!1)), i = i.slice(0, Math.min(i.length, c + 1));
  }
  let f = !1, u = -1;
  if (r && a && a.v7_partialHydration)
    for (let c = 0; c < i.length; c++) {
      let s = i[c];
      if ((s.route.HydrateFallback || s.route.hydrateFallbackElement) && (u = c), s.route.id) {
        let {
          loaderData: v,
          errors: m
        } = r, b = s.route.loader && v[s.route.id] === void 0 && (!m || m[s.route.id] === void 0);
        if (s.route.lazy || b) {
          f = !0, u >= 0 ? i = i.slice(0, u + 1) : i = [i[0]];
          break;
        }
      }
    }
  return i.reduceRight((c, s, v) => {
    let m, b = !1, C = null, E = null;
    r && (m = d && s.route.id ? d[s.route.id] : void 0, C = s.route.errorElement || Le, f && (u < 0 && v === 0 ? (pe("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), b = !0, E = null) : u === v && (b = !0, E = s.route.hydrateFallbackElement || null)));
    let V = t.concat(i.slice(0, v + 1)), h = () => {
      let P;
      return m ? P = C : b ? P = E : s.route.Component ? P = /* @__PURE__ */ n.createElement(s.route.Component, null) : s.route.element ? P = s.route.element : P = c, /* @__PURE__ */ n.createElement(Ie, {
        match: s,
        routeContext: {
          outlet: c,
          matches: V,
          isDataRoute: r != null
        },
        children: P
      });
    };
    return r && (s.route.ErrorBoundary || s.route.errorElement || v === 0) ? /* @__PURE__ */ n.createElement(Se, {
      location: r.location,
      revalidation: r.revalidation,
      component: C,
      error: m,
      children: h(),
      routeContext: {
        outlet: null,
        matches: V,
        isDataRoute: !0
      }
    }) : h();
  }, null);
}
var M = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(M || {}), y = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(y || {});
function q(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function K(e) {
  let t = n.useContext(F);
  return t || (process.env.NODE_ENV !== "production" ? p(!1, q(e)) : p(!1)), t;
}
function O(e) {
  let t = n.useContext(j);
  return t || (process.env.NODE_ENV !== "production" ? p(!1, q(e)) : p(!1)), t;
}
function we(e) {
  let t = n.useContext(N);
  return t || (process.env.NODE_ENV !== "production" ? p(!1, q(e)) : p(!1)), t;
}
function S(e) {
  let t = we(e), r = t.matches[t.matches.length - 1];
  return r.route.id || (process.env.NODE_ENV !== "production" ? p(!1, e + ' can only be used on routes that contain a unique "id"') : p(!1)), r.route.id;
}
function je() {
  return S(y.UseRouteId);
}
function Me() {
  return O(y.UseNavigation).navigation;
}
function Te() {
  let e = K(M.UseRevalidator), t = O(y.UseRevalidator);
  return n.useMemo(() => ({
    revalidate: e.router.revalidate,
    state: t.revalidation
  }), [e.router.revalidate, t.revalidation]);
}
function Ae() {
  let {
    matches: e,
    loaderData: t
  } = O(y.UseMatches);
  return n.useMemo(() => e.map((r) => me(r, t)), [e, t]);
}
function He() {
  let e = O(y.UseLoaderData), t = S(y.UseLoaderData);
  if (e.errors && e.errors[t] != null) {
    console.error("You cannot `useLoaderData` in an errorElement (routeId: " + t + ")");
    return;
  }
  return e.loaderData[t];
}
function ze(e) {
  return O(y.UseRouteLoaderData).loaderData[e];
}
function Je() {
  let e = O(y.UseActionData), t = S(y.UseLoaderData);
  return e.actionData ? e.actionData[t] : void 0;
}
function ce() {
  var e;
  let t = n.useContext(Y), r = O(y.UseRouteError), a = S(y.UseRouteError);
  return t !== void 0 ? t : (e = r.errors) == null ? void 0 : e[a];
}
function de() {
  let e = n.useContext(B);
  return e == null ? void 0 : e._data;
}
function Ye() {
  let e = n.useContext(B);
  return e == null ? void 0 : e._error;
}
let We = 0;
function qe(e) {
  let {
    router: t,
    basename: r
  } = K(M.UseBlocker), a = O(y.UseBlocker), [o, l] = n.useState(""), i = n.useCallback((d) => {
    if (typeof e != "function")
      return !!e;
    if (r === "/")
      return e(d);
    let {
      currentLocation: f,
      nextLocation: u,
      historyAction: c
    } = d;
    return e({
      currentLocation: _({}, f, {
        pathname: T(f.pathname, r) || f.pathname
      }),
      nextLocation: _({}, u, {
        pathname: T(u.pathname, r) || u.pathname
      }),
      historyAction: c
    });
  }, [r, e]);
  return n.useEffect(() => {
    let d = String(++We);
    return l(d), () => t.deleteBlocker(d);
  }, [t]), n.useEffect(() => {
    o !== "" && t.getBlocker(o, i);
  }, [t, o, i]), o && a.blockers.has(o) ? a.blockers.get(o) : Ee;
}
function Ke() {
  let {
    router: e
  } = K(M.UseNavigateStable), t = S(y.UseNavigateStable), r = n.useRef(!1);
  return ne(() => {
    r.current = !0;
  }), n.useCallback(function(o, l) {
    l === void 0 && (l = {}), process.env.NODE_ENV !== "production" && R(r.current, re), r.current && (typeof o == "number" ? e.navigate(o) : e.navigate(o, _({
      fromRouteId: t
    }, l)));
  }, [e, t]);
}
const X = {};
function pe(e, t, r) {
  !t && !X[e] && (X[e] = !0, process.env.NODE_ENV !== "production" && R(!1, r));
}
const Ge = "startTransition", w = n[Ge];
function Xe(e) {
  let {
    fallbackElement: t,
    router: r,
    future: a
  } = e, [o, l] = n.useState(r.state), {
    v7_startTransition: i
  } = a || {}, d = n.useCallback((s) => {
    i && w ? w(() => l(s)) : l(s);
  }, [l, i]);
  n.useLayoutEffect(() => r.subscribe(d), [r, d]), n.useEffect(() => {
    process.env.NODE_ENV !== "production" && R(t == null || !r.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
  }, []);
  let f = n.useMemo(() => ({
    createHref: r.createHref,
    encodeLocation: r.encodeLocation,
    go: (s) => r.navigate(s),
    push: (s, v, m) => r.navigate(s, {
      state: v,
      preventScrollReset: m == null ? void 0 : m.preventScrollReset
    }),
    replace: (s, v, m) => r.navigate(s, {
      replace: !0,
      state: v,
      preventScrollReset: m == null ? void 0 : m.preventScrollReset
    })
  }), [r]), u = r.basename || "/", c = n.useMemo(() => ({
    router: r,
    navigator: f,
    static: !1,
    basename: u
  }), [r, f, u]);
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(F.Provider, {
    value: c
  }, /* @__PURE__ */ n.createElement(j.Provider, {
    value: o
  }, /* @__PURE__ */ n.createElement(G, {
    basename: u,
    location: o.location,
    navigationType: o.historyAction,
    navigator: f,
    future: {
      v7_relativeSplatPath: r.future.v7_relativeSplatPath
    }
  }, o.initialized || r.future.v7_partialHydration ? /* @__PURE__ */ n.createElement(Qe, {
    routes: r.routes,
    future: r.future,
    state: o
  }) : t))), null);
}
function Qe(e) {
  let {
    routes: t,
    future: r,
    state: a
  } = e;
  return W(t, void 0, a, r);
}
function Ze(e) {
  let {
    basename: t,
    children: r,
    initialEntries: a,
    initialIndex: o,
    future: l
  } = e, i = n.useRef();
  i.current == null && (i.current = ee({
    initialEntries: a,
    initialIndex: o,
    v5Compat: !0
  }));
  let d = i.current, [f, u] = n.useState({
    action: d.action,
    location: d.location
  }), {
    v7_startTransition: c
  } = l || {}, s = n.useCallback((v) => {
    c && w ? w(() => u(v)) : u(v);
  }, [u, c]);
  return n.useLayoutEffect(() => d.listen(s), [d, s]), /* @__PURE__ */ n.createElement(G, {
    basename: t,
    children: r,
    location: f.location,
    navigationType: f.action,
    navigator: d,
    future: l
  });
}
function $e(e) {
  let {
    to: t,
    replace: r,
    state: a,
    relative: o
  } = e;
  D() || (process.env.NODE_ENV !== "production" ? p(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component."
  ) : p(!1));
  let {
    future: l,
    static: i
  } = n.useContext(x);
  process.env.NODE_ENV !== "production" && R(!i, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
  let {
    matches: d
  } = n.useContext(N), {
    pathname: f
  } = k(), u = ae(), c = H(t, A(d, l.v7_relativeSplatPath), f, o === "path"), s = JSON.stringify(c);
  return n.useEffect(() => u(JSON.parse(s), {
    replace: r,
    state: a,
    relative: o
  }), [u, s, o, r, a]), null;
}
function et(e) {
  return ie(e.context);
}
function fe(e) {
  process.env.NODE_ENV !== "production" ? p(!1, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.") : p(!1);
}
function G(e) {
  let {
    basename: t = "/",
    children: r = null,
    location: a,
    navigationType: o = z.Pop,
    navigator: l,
    static: i = !1,
    future: d
  } = e;
  D() && (process.env.NODE_ENV !== "production" ? p(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : p(!1));
  let f = t.replace(/^\/*/, "/"), u = n.useMemo(() => ({
    basename: f,
    navigator: l,
    static: i,
    future: _({
      v7_relativeSplatPath: !1
    }, d)
  }), [f, d, l, i]);
  typeof a == "string" && (a = J(a));
  let {
    pathname: c = "/",
    search: s = "",
    hash: v = "",
    state: m = null,
    key: b = "default"
  } = a, C = n.useMemo(() => {
    let E = T(c, f);
    return E == null ? null : {
      location: {
        pathname: E,
        search: s,
        hash: v,
        state: m,
        key: b
      },
      navigationType: o
    };
  }, [f, c, s, v, m, b, o]);
  return process.env.NODE_ENV !== "production" && R(C != null, '<Router basename="' + f + '"> is not able to match the URL ' + ('"' + c + s + v + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), C == null ? null : /* @__PURE__ */ n.createElement(x.Provider, {
    value: u
  }, /* @__PURE__ */ n.createElement(U.Provider, {
    children: r,
    value: C
  }));
}
function tt(e) {
  let {
    children: t,
    location: r
  } = e;
  return se(L(t), r);
}
function rt(e) {
  let {
    children: t,
    errorElement: r,
    resolve: a
  } = e;
  return /* @__PURE__ */ n.createElement(at, {
    resolve: a,
    errorElement: r
  }, /* @__PURE__ */ n.createElement(ot, null, t));
}
var g = /* @__PURE__ */ function(e) {
  return e[e.pending = 0] = "pending", e[e.success = 1] = "success", e[e.error = 2] = "error", e;
}(g || {});
const nt = new Promise(() => {
});
class at extends n.Component {
  constructor(t) {
    super(t), this.state = {
      error: null
    };
  }
  static getDerivedStateFromError(t) {
    return {
      error: t
    };
  }
  componentDidCatch(t, r) {
    console.error("<Await> caught the following error during render", t, r);
  }
  render() {
    let {
      children: t,
      errorElement: r,
      resolve: a
    } = this.props, o = null, l = g.pending;
    if (!(a instanceof Promise))
      l = g.success, o = Promise.resolve(), Object.defineProperty(o, "_tracked", {
        get: () => !0
      }), Object.defineProperty(o, "_data", {
        get: () => a
      });
    else if (this.state.error) {
      l = g.error;
      let i = this.state.error;
      o = Promise.reject().catch(() => {
      }), Object.defineProperty(o, "_tracked", {
        get: () => !0
      }), Object.defineProperty(o, "_error", {
        get: () => i
      });
    } else a._tracked ? (o = a, l = "_error" in o ? g.error : "_data" in o ? g.success : g.pending) : (l = g.pending, Object.defineProperty(a, "_tracked", {
      get: () => !0
    }), o = a.then((i) => Object.defineProperty(a, "_data", {
      get: () => i
    }), (i) => Object.defineProperty(a, "_error", {
      get: () => i
    })));
    if (l === g.error && o._error instanceof te)
      throw nt;
    if (l === g.error && !r)
      throw o._error;
    if (l === g.error)
      return /* @__PURE__ */ n.createElement(B.Provider, {
        value: o,
        children: r
      });
    if (l === g.success)
      return /* @__PURE__ */ n.createElement(B.Provider, {
        value: o,
        children: t
      });
    throw o;
  }
}
function ot(e) {
  let {
    children: t
  } = e, r = de(), a = typeof t == "function" ? t(r) : t;
  return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
}
function L(e, t) {
  t === void 0 && (t = []);
  let r = [];
  return n.Children.forEach(e, (a, o) => {
    if (!/* @__PURE__ */ n.isValidElement(a))
      return;
    let l = [...t, o];
    if (a.type === n.Fragment) {
      r.push.apply(r, L(a.props.children, l));
      return;
    }
    a.type !== fe && (process.env.NODE_ENV !== "production" ? p(!1, "[" + (typeof a.type == "string" ? a.type : a.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>") : p(!1)), !a.props.index || !a.props.children || (process.env.NODE_ENV !== "production" ? p(!1, "An index route cannot have child routes.") : p(!1));
    let i = {
      id: a.props.id || l.join("-"),
      caseSensitive: a.props.caseSensitive,
      element: a.props.element,
      Component: a.props.Component,
      index: a.props.index,
      path: a.props.path,
      loader: a.props.loader,
      action: a.props.action,
      errorElement: a.props.errorElement,
      ErrorBoundary: a.props.ErrorBoundary,
      hasErrorBoundary: a.props.ErrorBoundary != null || a.props.errorElement != null,
      shouldRevalidate: a.props.shouldRevalidate,
      handle: a.props.handle,
      lazy: a.props.lazy
    };
    a.props.children && (i.children = L(a.props.children, l)), r.push(i);
  }), r;
}
function it(e) {
  return ue(e);
}
function ve(e) {
  let t = {
    // Note: this check also occurs in createRoutesFromChildren so update
    // there if you change this -- please and thank you!
    hasErrorBoundary: e.ErrorBoundary != null || e.errorElement != null
  };
  return e.Component && (process.env.NODE_ENV !== "production" && e.element && process.env.NODE_ENV !== "production" && R(!1, "You should not include both `Component` and `element` on your route - `Component` will be used."), Object.assign(t, {
    element: /* @__PURE__ */ n.createElement(e.Component),
    Component: void 0
  })), e.HydrateFallback && (process.env.NODE_ENV !== "production" && e.hydrateFallbackElement && process.env.NODE_ENV !== "production" && R(!1, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used."), Object.assign(t, {
    hydrateFallbackElement: /* @__PURE__ */ n.createElement(e.HydrateFallback),
    HydrateFallback: void 0
  })), e.ErrorBoundary && (process.env.NODE_ENV !== "production" && e.errorElement && process.env.NODE_ENV !== "production" && R(!1, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used."), Object.assign(t, {
    errorElement: /* @__PURE__ */ n.createElement(e.ErrorBoundary),
    ErrorBoundary: void 0
  })), t;
}
function lt(e, t) {
  return ye({
    basename: t == null ? void 0 : t.basename,
    future: _({}, t == null ? void 0 : t.future, {
      v7_prependBasename: !0
    }),
    history: ee({
      initialEntries: t == null ? void 0 : t.initialEntries,
      initialIndex: t == null ? void 0 : t.initialIndex
    }),
    hydrationData: t == null ? void 0 : t.hydrationData,
    routes: e,
    mapRouteProperties: ve,
    dataStrategy: t == null ? void 0 : t.dataStrategy,
    patchRoutesOnNavigation: t == null ? void 0 : t.patchRoutesOnNavigation
  }).initialize();
}
const ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedDeferredError: te,
  Await: rt,
  MemoryRouter: Ze,
  Navigate: $e,
  get NavigationType() {
    return z;
  },
  Outlet: et,
  Route: fe,
  Router: G,
  RouterProvider: Xe,
  Routes: tt,
  UNSAFE_DataRouterContext: F,
  UNSAFE_DataRouterStateContext: j,
  UNSAFE_LocationContext: U,
  UNSAFE_NavigationContext: x,
  UNSAFE_RouteContext: N,
  UNSAFE_mapRouteProperties: ve,
  UNSAFE_useRouteId: je,
  UNSAFE_useRoutesImpl: W,
  createMemoryRouter: lt,
  createPath: ge,
  createRoutesFromChildren: L,
  createRoutesFromElements: L,
  defer: Ne,
  generatePath: be,
  isRouteErrorResponse: $,
  json: Re,
  matchPath: Z,
  matchRoutes: Q,
  parsePath: J,
  redirect: Ce,
  redirectDocument: xe,
  renderMatches: it,
  replace: _e,
  resolvePath: De,
  useActionData: Je,
  useAsyncError: Ye,
  useAsyncValue: de,
  useBlocker: qe,
  useHref: Oe,
  useInRouterContext: D,
  useLoaderData: He,
  useLocation: k,
  useMatch: Ue,
  useMatches: Ae,
  useNavigate: ae,
  useNavigation: Me,
  useNavigationType: Pe,
  useOutlet: ie,
  useOutletContext: Fe,
  useParams: ke,
  useResolvedPath: le,
  useRevalidator: Te,
  useRouteError: ce,
  useRouteLoaderData: ze,
  useRoutes: se
}, Symbol.toStringTag, { value: "Module" }));
export {
  rt as A,
  ie as B,
  Fe as C,
  j as D,
  Te as E,
  ce as F,
  ze as G,
  se as H,
  ut as I,
  U as L,
  Ze as M,
  x as N,
  et as O,
  N as R,
  ae as a,
  ke as b,
  Oe as c,
  le as d,
  je as e,
  F as f,
  G as g,
  W as h,
  Ae as i,
  Me as j,
  qe as k,
  $e as l,
  ve as m,
  fe as n,
  tt as o,
  lt as p,
  L as q,
  it as r,
  Je as s,
  Ye as t,
  k as u,
  de as v,
  D as w,
  He as x,
  Ue as y,
  Pe as z
};
//# sourceMappingURL=index-Czzd9rjU.js.map
